import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"
import _imports_0 from '@/assets/pdf.svg'
import _imports_1 from '@/assets/doc.svg'
import _imports_2 from '@/assets/docx.svg'
import _imports_3 from '@/assets/xls.svg'
import _imports_4 from '@/assets/xlsx.svg'
import _imports_5 from '@/assets/txt.svg'
import _imports_6 from '@/assets/png.svg'
import _imports_7 from '@/assets/jpg.svg'
import _imports_8 from '@/assets/jpeg.svg'
import _imports_9 from '@/assets/csv.svg'
import _imports_10 from '@/assets/zip.svg'
import _imports_11 from '@/assets/mp4.svg'
import _imports_12 from '@/assets/deleteIcon.svg'
import _imports_13 from '@/assets/sortBy.svg'
import _imports_14 from '@/assets/arrowRight.svg'
import _imports_15 from '@/assets/warning.svg'
import _imports_16 from '@/assets/cancel.svg'
import _imports_17 from '@/assets/fileUploadIcon.svg'
import _imports_18 from '@/assets/Browse.svg'
import _imports_19 from '@/assets/filterIcon.svg'


const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "items-center justify-between flex" }
const _hoisted_3 = {
  key: 0,
  class: "title flex items-center"
}
const _hoisted_4 = {
  key: 0,
  class: "flex flex-row items-center"
}
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "w-full minheight" }
const _hoisted_8 = { class: "w-full" }
const _hoisted_9 = { class: "text-sm" }
const _hoisted_10 = { class: "mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pt-5 pb-3 border-lightgrey" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = {
  key: 0,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "w-6/12" }
const _hoisted_17 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_18 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_19 = { class: "w-6/12" }
const _hoisted_20 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_21 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_22 = { class: "flex" }
const _hoisted_23 = { class: "w-6/12" }
const _hoisted_24 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_25 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_26 = { class: "w-6/12" }
const _hoisted_27 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_28 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_29 = { class: "flex flex-row mt-3" }
const _hoisted_30 = { class: "w-6/12" }
const _hoisted_31 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_32 = { class: "flex" }
const _hoisted_33 = { class: "w-6/12" }
const _hoisted_34 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_35 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_36 = { class: "w-6/12" }
const _hoisted_37 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_38 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_39 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_40 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_41 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_42 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_43 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_44 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_45 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_46 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "mt-1 mb-4" }
const _hoisted_49 = { key: 1 }
const _hoisted_50 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_51 = { class: "row flex flex-row w-full" }
const _hoisted_52 = { class: "w-6/12" }
const _hoisted_53 = { class: "w-6/12 leftspacing" }
const _hoisted_54 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_55 = { class: "row flex flex-row w-full" }
const _hoisted_56 = { class: "w-6/12" }
const _hoisted_57 = { class: "w-6/12 leftspacing" }
const _hoisted_58 = { class: "formcontainer upperspacing" }
const _hoisted_59 = { class: "row flex flex-row w-full" }
const _hoisted_60 = { class: "w-3/6" }
const _hoisted_61 = { class: "w-3/6 leftspacing" }
const _hoisted_62 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_63 = { class: "row flex flex-row w-full" }
const _hoisted_64 = { class: "w-6/12" }
const _hoisted_65 = { class: "w-6/12 leftspacing" }
const _hoisted_66 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_67 = { class: "row flex flex-row w-full" }
const _hoisted_68 = { class: "w-6/12" }
const _hoisted_69 = { class: "w-6/12 leftspacing" }
const _hoisted_70 = { class: "formcontainer upperspacing" }
const _hoisted_71 = { class: "row flex flex-row w-full" }
const _hoisted_72 = { class: "w-3/6" }
const _hoisted_73 = { class: "w-3/6 leftspacing" }
const _hoisted_74 = {
  key: 1,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_75 = { class: "flex mb-1" }
const _hoisted_76 = { class: "w-6/12" }
const _hoisted_77 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_78 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_79 = { class: "w-6/12" }
const _hoisted_80 = {
  key: 1,
  class: "text-sm mt-2"
}
const _hoisted_81 = { class: "flex mb-1" }
const _hoisted_82 = { class: "w-6/12" }
const _hoisted_83 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_84 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_85 = { class: "w-6/12" }
const _hoisted_86 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_87 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_88 = { class: "flex mb-1" }
const _hoisted_89 = { class: "w-6/12" }
const _hoisted_90 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_91 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_92 = { class: "w-6/12" }
const _hoisted_93 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_94 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_95 = { class: "w-full" }
const _hoisted_96 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_97 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_98 = { class: "w-full" }
const _hoisted_99 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_100 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_101 = { class: "w-full" }
const _hoisted_102 = {
  key: 0,
  class: "mt-1 mb-3 text-sm"
}
const _hoisted_103 = {
  key: 1,
  class: "text-sm mt-1 mb-3"
}
const _hoisted_104 = { class: "w-full" }
const _hoisted_105 = {
  key: 0,
  class: "mt-1 text-sm"
}
const _hoisted_106 = {
  key: 1,
  class: "text-sm mt-1"
}
const _hoisted_107 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_108 = { class: "row flex flex-row w-full" }
const _hoisted_109 = { class: "w-6/12" }
const _hoisted_110 = { class: "w-6/12 leftspacing" }
const _hoisted_111 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_112 = { class: "row flex flex-row w-full" }
const _hoisted_113 = { class: "w-6/12" }
const _hoisted_114 = { class: "w-6/12 leftspacing" }
const _hoisted_115 = { class: "formcontainer upperspacing" }
const _hoisted_116 = { class: "row flex flex-row w-full" }
const _hoisted_117 = { class: "w-3/6" }
const _hoisted_118 = { class: "w-3/6 leftspacing" }
const _hoisted_119 = { key: 0 }
const _hoisted_120 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_121 = { class: "row flex flex-row w-full" }
const _hoisted_122 = { class: "w-6/12" }
const _hoisted_123 = { class: "w-6/12 leftspacing" }
const _hoisted_124 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_125 = { class: "row flex flex-row w-full" }
const _hoisted_126 = { class: "w-6/12" }
const _hoisted_127 = { class: "w-6/12 leftspacing" }
const _hoisted_128 = { class: "formcontainer upperspacing" }
const _hoisted_129 = { class: "row flex flex-row w-full" }
const _hoisted_130 = { class: "w-3/6" }
const _hoisted_131 = { class: "w-3/6 leftspacing" }
const _hoisted_132 = {
  key: 2,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_133 = {
  key: 3,
  class: "overflow-y-scroll descriptionToggle evidence-description"
}
const _hoisted_134 = { class: "evidence-tab-content" }
const _hoisted_135 = { class: "evidence-files-block" }
const _hoisted_136 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_137 = { class: "buttonposition flex justify-center items-center sendapprovalheight gap-2" }
const _hoisted_138 = { class: "evidence-files-section" }
const _hoisted_139 = {
  key: 0,
  class: "flex mt-4 gap-4 flex-wrap"
}
const _hoisted_140 = { class: "pdf" }
const _hoisted_141 = ["onClick"]
const _hoisted_142 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_143 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_144 = {
  key: 2,
  src: _imports_2,
  alt: ""
}
const _hoisted_145 = {
  key: 3,
  src: _imports_3,
  alt: ""
}
const _hoisted_146 = {
  key: 4,
  src: _imports_4,
  alt: ""
}
const _hoisted_147 = {
  key: 5,
  src: _imports_0,
  alt: ""
}
const _hoisted_148 = {
  key: 6,
  src: _imports_5,
  alt: ""
}
const _hoisted_149 = {
  key: 7,
  src: _imports_6,
  alt: ""
}
const _hoisted_150 = {
  key: 8,
  src: _imports_7,
  alt: ""
}
const _hoisted_151 = {
  key: 9,
  src: _imports_8,
  alt: ""
}
const _hoisted_152 = {
  key: 10,
  src: _imports_9,
  alt: ""
}
const _hoisted_153 = {
  key: 11,
  src: _imports_10,
  alt: ""
}
const _hoisted_154 = {
  key: 12,
  src: _imports_11,
  alt: ""
}
const _hoisted_155 = { class: "evidence-file-text" }
const _hoisted_156 = { class: "evidence-file-top" }
const _hoisted_157 = ["title"]
const _hoisted_158 = ["onClick"]
const _hoisted_159 = { class: "evidence-file-meta" }
const _hoisted_160 = { class: "evidence-file-date" }
const _hoisted_161 = ["title"]
const _hoisted_162 = {
  key: 1,
  class: "text-xs text-placeholdergray mt-3"
}
const _hoisted_163 = { class: "evidence-links-section" }
const _hoisted_164 = { class: "border-b border-lightgrey flex justify-between mt-6" }
const _hoisted_165 = { class: "buttonposition flex justify-center items-center sendapprovalheight gap-2" }
const _hoisted_166 = { class: "evidence-links-scroll" }
const _hoisted_167 = { class: "evidence-links-header" }
const _hoisted_168 = { class: "flex items-center" }
const _hoisted_169 = { class: "flex items-center" }
const _hoisted_170 = { class: "flex items-center" }
const _hoisted_171 = { class: "evidence-links-body" }
const _hoisted_172 = { key: 0 }
const _hoisted_173 = ["title"]
const _hoisted_174 = { class: "table-ellipsis" }
const _hoisted_175 = { class: "table-ellipsis" }
const _hoisted_176 = ["onClick", "title"]
const _hoisted_177 = { class: "evidence-links-col-action" }
const _hoisted_178 = ["onClick"]
const _hoisted_179 = { key: 1 }
const _hoisted_180 = {
  key: 4,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_181 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_182 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_183 = { class: "comment-box w-full" }
const _hoisted_184 = { class: "my-3" }
const _hoisted_185 = {
  key: 0,
  class: "comments"
}
const _hoisted_186 = { class: "initials" }
const _hoisted_187 = { class: "w-1/5" }
const _hoisted_188 = { class: "header" }
const _hoisted_189 = { class: "fontSize10PX" }
const _hoisted_190 = { class: "w-4/5 text-xs" }
const _hoisted_191 = {
  key: 5,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_192 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_193 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_194 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_195 = {
  key: 0,
  class: "initials"
}
const _hoisted_196 = {
  key: 1,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_197 = {
  key: 2,
  class: "initials"
}
const _hoisted_198 = {
  key: 3,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_199 = {
  key: 4,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_200 = {
  key: 5,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_201 = {
  key: 6,
  class: "mx-2 mt-1 text-xs"
}
const _hoisted_202 = {
  key: 7,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_203 = {
  key: 8,
  class: "font-semibold mt-1 text-xs"
}
const _hoisted_204 = {
  key: 6,
  class: "overflow-y-scroll descriptionToggle"
}
const _hoisted_205 = { class: "border-b border-lightgrey flex justify-between" }
const _hoisted_206 = { class: "buttonposition flex justify-center items-center sendapprovalheight" }
const _hoisted_207 = { class: "buttonposition flex justify-center items-center" }
const _hoisted_208 = { class: "flex" }
const _hoisted_209 = {
  key: 0,
  class: "initials"
}
const _hoisted_210 = {
  key: 1,
  class: "initials"
}
const _hoisted_211 = { class: "logContainer w-93" }
const _hoisted_212 = { class: "flex mt-1" }
const _hoisted_213 = {
  key: 0,
  class: "font-semibold text-xs"
}
const _hoisted_214 = {
  key: 1,
  class: "font-semibold text-xs"
}
const _hoisted_215 = {
  key: 2,
  class: "mx-2 text-xs"
}
const _hoisted_216 = {
  key: 3,
  class: "mx-2 text-xs"
}
const _hoisted_217 = {
  key: 4,
  class: "mx-2 text-xs"
}
const _hoisted_218 = {
  key: 5,
  class: "font-semibold text-xs"
}
const _hoisted_219 = {
  key: 6,
  class: "font-semibold text-xs"
}
const _hoisted_220 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_221 = {
  key: 0,
  class: "flex"
}
const _hoisted_222 = { class: "text-xs w-full text-justify" }
const _hoisted_223 = {
  key: 1,
  class: "flex"
}
const _hoisted_224 = {
  key: 0,
  class: "font-normal text-xs ml-2"
}
const _hoisted_225 = {
  key: 1,
  class: "font-normal text-xs ml-2"
}
const _hoisted_226 = {
  key: 2,
  class: "font-normal text-xs ml-2"
}
const _hoisted_227 = {
  key: 3,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_228 = {
  key: 4,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_229 = {
  key: 5,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_230 = {
  key: 6,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_231 = {
  key: 7,
  class: "font-semibold text-xs"
}
const _hoisted_232 = {
  key: 8,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_233 = {
  key: 9,
  class: "font-semibold text-xs ml-2"
}
const _hoisted_234 = {
  key: 10,
  class: "font-semibold text-xs"
}
const _hoisted_235 = {
  key: 2,
  class: "flex"
}
const _hoisted_236 = { class: "mx-2 text-xs" }
const _hoisted_237 = {
  key: 3,
  class: "flex mt-2"
}
const _hoisted_238 = { class: "mx-2 text-xs" }
const _hoisted_239 = {
  key: 4,
  class: "flex"
}
const _hoisted_240 = { class: "font-semibold text-xs" }
const _hoisted_241 = { class: "mx-2 text-xs" }
const _hoisted_242 = {
  key: 5,
  class: "flex mt-2"
}
const _hoisted_243 = { class: "mx-2 text-xs" }
const _hoisted_244 = {
  key: 6,
  class: "flex"
}
const _hoisted_245 = { class: "mx-2 text-xs" }
const _hoisted_246 = {
  key: 7,
  class: "flex"
}
const _hoisted_247 = { class: "mx-2 text-xs text-justify" }
const _hoisted_248 = { class: "mx-2 text-xs text-justify" }
const _hoisted_249 = {
  key: 2,
  class: "flex flex-col gap-1"
}
const _hoisted_250 = { class: "flex items-center" }
const _hoisted_251 = { class: "mx-2 text-xs text-justify" }
const _hoisted_252 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_253 = { class: "text-xs text-justify" }
const _hoisted_254 = {
  key: 8,
  class: "flex items-center"
}
const _hoisted_255 = { class: "flex ml-4" }
const _hoisted_256 = {
  key: 9,
  class: "flex items-center gap-2 mt-2"
}
const _hoisted_257 = { class: "text-xs text-justify" }
const _hoisted_258 = { class: "w-20 border taskDetailsRightBar rounded-sm border-lightgrey" }
const _hoisted_259 = { class: "m-3" }
const _hoisted_260 = { key: 0 }
const _hoisted_261 = { class: "flex items-center justify-center w-full h-16 skeleton" }
const _hoisted_262 = {
  key: 1,
  class: "pt-1.5 overflow-y-scroll thirtyWidthToggle"
}
const _hoisted_263 = { class: "flex flex-col mb-3" }
const _hoisted_264 = { key: 6 }
const _hoisted_265 = { class: "mb-3" }
const _hoisted_266 = { class: "mb-3" }
const _hoisted_267 = { class: "my-1" }
const _hoisted_268 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_269 = { class: "mb-3" }
const _hoisted_270 = ["disabled", "max"]
const _hoisted_271 = { class: "mb-3" }
const _hoisted_272 = ["disabled", "min"]
const _hoisted_273 = { class: "mb-3" }
const _hoisted_274 = ["min", "disabled"]
const _hoisted_275 = { class: "mb-3" }
const _hoisted_276 = { class: "mb-3" }
const _hoisted_277 = { class: "mb-3" }
const _hoisted_278 = { class: "mb-3" }
const _hoisted_279 = {
  key: 1,
  class: "evidence-delete-confirm"
}
const _hoisted_280 = { class: "evidence-delete-dialog" }
const _hoisted_281 = { class: "evidence-delete-dialog-actions" }
const _hoisted_282 = { class: "overflow-x-hidden overflow-y-auto fixed inset-0 z-index justify-end items-start flex" }
const _hoisted_283 = { class: "relative w-full max-w-xl" }
const _hoisted_284 = { class: "border-0 rounded relative flex flex-col w-full bg-white h-screen" }
const _hoisted_285 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_286 = { class: "impactcontainer popupbodycontainer flex-1 overflow-y-auto" }
const _hoisted_287 = { class: "formcontainer flex flex-col h-full" }
const _hoisted_288 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_289 = { class: "row flex flex-col mt-2" }
const _hoisted_290 = { class: "controllabel" }
const _hoisted_291 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_292 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_293 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_294 = {
  key: 0,
  class: "pt-3"
}
const _hoisted_295 = {
  key: 0,
  class: "text-sm font-semibold text-darkblue mb-4"
}
const _hoisted_296 = {
  key: 1,
  class: "text-sm font-semibold text-primary mb-4"
}
const _hoisted_297 = { class: "flex items-center justify-center gap-2" }
const _hoisted_298 = ["disabled"]
const _hoisted_299 = { class: "min-h-[22px] text-red-500" }
const _hoisted_300 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_301 = {
  key: 1,
  class: "text-red-500 text-xs"
}
const _hoisted_302 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_303 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_304 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_305 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_306 = { class: "pt-3 w-1/2" }
const _hoisted_307 = ["max"]
const _hoisted_308 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_309 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_310 = { class: "buttonposition flex justify-end items-center pt-4" }
const _hoisted_311 = {
  key: 3,
  class: "link-existing-confirm"
}
const _hoisted_312 = { class: "link-existing-dialog" }
const _hoisted_313 = { class: "link-existing-tables" }
const _hoisted_314 = { class: "link-existing-section-row" }
const _hoisted_315 = { class: "link-existing-section" }
const _hoisted_316 = { class: "link-existing-table" }
const _hoisted_317 = { class: "flex table-header-label-wrap" }
const _hoisted_318 = { class: "flex table-header-label-wrap" }
const _hoisted_319 = { class: "flex table-header-label-wrap" }
const _hoisted_320 = { class: "flex table-header-label-wrap" }
const _hoisted_321 = {
  key: 0,
  class: "link-existing-filter-row"
}
const _hoisted_322 = { key: 0 }
const _hoisted_323 = { class: "link-existing-col-check" }
const _hoisted_324 = ["checked", "onChange"]
const _hoisted_325 = ["title"]
const _hoisted_326 = { key: 1 }
const _hoisted_327 = { class: "link-existing-actions" }
const _hoisted_328 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_329 = { class: "popup-business flex-1 overflow-y-auto" }
const _hoisted_330 = { class: "flex flex-col h-full" }
const _hoisted_331 = { class: "flex-1 overflow-auto hide-scrollbar" }
const _hoisted_332 = { class: "statuscontainer px-5 pb-5" }
const _hoisted_333 = { class: "formcontainer flex flex-col" }
const _hoisted_334 = { class: "row flex flex-row upperspacing" }
const _hoisted_335 = { class: "w-1/2" }
const _hoisted_336 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_337 = {
  key: 0,
  class: "error-text"
}
const _hoisted_338 = { class: "row flex flex-row upperspacing" }
const _hoisted_339 = { class: "w-full" }
const _hoisted_340 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_341 = {
  key: 0,
  class: "error-text"
}
const _hoisted_342 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_343 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_344 = { class: "flex flex-col h-full" }
const _hoisted_345 = { class: "flex-1 overflow-auto" }
const _hoisted_346 = { class: "popup-business" }
const _hoisted_347 = { class: "statuscontainer px-4 py-4" }
const _hoisted_348 = { class: "formcontainer flex flex-col w-full" }
const _hoisted_349 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_350 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_351 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_352 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_breadCrumbs = _resolveComponent("breadCrumbs")!
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_dotsloader = _resolveComponent("dotsloader")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_commentsEditor = _resolveComponent("commentsEditor")!
  const _component_safeHtml = _resolveComponent("safeHtml")!
  const _component_TabPanel = _resolveComponent("TabPanel")!
  const _component_TabPanels = _resolveComponent("TabPanels")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.modalMode ? 'task-details-in-modal' : 'mb-5 mx-5 mt-3 ResponsiveControlePage')
  }, [
    (!_ctx.modalMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_breadCrumbs, { routesArray: _ctx.routesArray }, null, 8, ["routesArray"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.modalMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("h1", {
              class: _normalizeClass(_ctx.presentSubTask.TaskName!=undefined && _ctx.presentSubTask.TaskName!='' && _ctx.presentSubTask.TaskName.length > 0 > 40? 'heading-ellipsis':'')
            }, _toDisplayString(_ctx.presentSubTask.TaskName), 3)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_ctx.checkOwner() && (_ctx.presentSubTask.statusCode == 10421))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("button", {
                class: "btnprimary items-center mr-2",
                disabled: _ctx.clickOnButton,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approveOrRejectTheParentApproval(10403)))
              }, "Approve", 8, _hoisted_5),
              _createElementVNode("button", {
                class: "btnprimary items-center",
                disabled: _ctx.clickOnButton,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickToRejectByJustificationAtInReview()))
              }, "Reject", 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_Tabs, {
                value: _ctx.selectedTabIndex,
                "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedTabIndex) = $event)),
                scrollable: "",
                class: "w-80 heightFixing pr-5"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_TabList, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                          return (_openBlock(), _createBlock(_component_Tab, {
                            key: tabIndex,
                            value: tab.id,
                            onClick: ($event: any) => (_ctx.toggleTabs(tab))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tab.displayName), 1)
                            ]),
                            _: 2
                          }, 1032, ["value", "onClick"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_TabPanels, { class: "overflow-auto hide-scrollbar" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabHead, (tab, tabIndex) => {
                        return (_openBlock(), _createBlock(_component_TabPanel, {
                          key: tabIndex,
                          value: tab.id
                        }, {
                          default: _withCtx(() => [
                            (_ctx.dotsLoader == true)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createVNode(_component_dotsloader)
                                  ])
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  (tab.id == 1 && (_ctx.presentSubTask.appId!=10003 ||(_ctx.presentSubTask.hasOwnProperty('control') && _ctx.presentSubTask.treatmentType==10405)))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _createElementVNode("div", _hoisted_15, [
                                          _createElementVNode("div", _hoisted_16, [
                                            _cache[81] || (_cache[81] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "CID", -1)),
                                            ((_ctx.linkedControlDetails[0]?.clientUniqueId||'N/A'))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.linkedControlDetails[0]?.clientUniqueId ||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_18, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_19, [
                                            _cache[82] || (_cache[82] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Frequency", -1)),
                                            ((_ctx.presentSubTask?.controlFrequency||'N/A'))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(_ctx.getControlFrequency(_ctx.presentSubTask?.controlFrequency)||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_21, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_22, [
                                          _createElementVNode("div", _hoisted_23, [
                                            _cache[83] || (_cache[83] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Title", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlTitle))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.linkedControlDetails[0]?.controlTitle||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_25, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_26, [
                                            _cache[84] || (_cache[84] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Type", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlType))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_27, _toDisplayString(_ctx.linkedControlDetails[0]?.controlType||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_28, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_29, [
                                          _createElementVNode("div", _hoisted_30, [
                                            _cache[85] || (_cache[85] = _createElementVNode("label", { class: "font-extrabold text-xs" }, "Priority", -1)),
                                            (_ctx.linkedControlDetails[0]?.controlPriority && typeof _ctx.linkedControlDetails[0]?.controlPriority === 'number')
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.linkedControlDetails[0]?.controlPriority)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.linkedControlDetails[0]?.controlPriority)])
                                                  }, _toDisplayString(_ctx.getProirityLabel(_ctx.linkedControlDetails[0]?.controlPriority)), 3)
                                                ], 2))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_31, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", _hoisted_32, [
                                          _createElementVNode("div", _hoisted_33, [
                                            _cache[86] || (_cache[86] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Class", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlClass))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(_ctx.linkedControlDetails[0]?.controlClass||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_35, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_36, [
                                            _cache[87] || (_cache[87] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Family", -1)),
                                            ((_ctx.linkedControlDetails[0]?.controlFamily))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_37, _toDisplayString(_ctx.linkedControlDetails[0]?.controlFamily||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_38, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[88] || (_cache[88] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Description", -1)),
                                          ((_ctx.linkedControlDetails[0]?.Description))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_39, _toDisplayString(_ctx.linkedControlDetails[0]?.Description||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_40, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[89] || (_cache[89] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Policy/Procedure", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlPolicies))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_41, _toDisplayString(_ctx.linkedControlDetails[0]?.controlPolicies||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_42, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[90] || (_cache[90] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Guidance", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlGuidance))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_43, _toDisplayString(_ctx.linkedControlDetails[0]?.controlGuidance||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_44, "N/A"))
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[91] || (_cache[91] = _createElementVNode("label", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Task", -1)),
                                          ((_ctx.linkedControlDetails[0]?.controlMaintenanceTask))
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.linkedControlDetails[0]?.controlMaintenanceTask||'N/A'), 1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_46, "N/A"))
                                        ]),
                                        (_ctx.presentSubTask.notes)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                              _createElementVNode("div", null, [
                                                _cache[92] || (_cache[92] = _createElementVNode("p", { class: "mt-2 mb-1 header" }, "Notes", -1)),
                                                _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.presentSubTask.notes), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (_ctx.presentSubTask.residual && _ctx.presentSubTask.residual!=undefined && _ctx.presentSubTask.residual!='')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _cache[105] || (_cache[105] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                              _cache[106] || (_cache[106] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("div", _hoisted_51, [
                                                  _createElementVNode("div", _hoisted_52, [
                                                    _cache[93] || (_cache[93] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_53, [
                                                    _cache[94] || (_cache[94] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_54, [
                                                _createElementVNode("div", _hoisted_55, [
                                                  _createElementVNode("div", _hoisted_56, [
                                                    _cache[95] || (_cache[95] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_57, [
                                                    _cache[96] || (_cache[96] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_58, [
                                                _createElementVNode("div", _hoisted_59, [
                                                  _createElementVNode("div", _hoisted_60, [
                                                    _cache[97] || (_cache[97] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_61, [
                                                    _cache[98] || (_cache[98] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _cache[107] || (_cache[107] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                              _cache[108] || (_cache[108] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_62, [
                                                _createElementVNode("div", _hoisted_63, [
                                                  _createElementVNode("div", _hoisted_64, [
                                                    _cache[99] || (_cache[99] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask?.residual?.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask?.residual?.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask?.residual?.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_65, [
                                                    _cache[100] || (_cache[100] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask?.residual?.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask?.residual?.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask?.residual?.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_66, [
                                                _createElementVNode("div", _hoisted_67, [
                                                  _createElementVNode("div", _hoisted_68, [
                                                    _cache[101] || (_cache[101] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask?.residual?.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask?.residual?.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask?.residual?.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_69, [
                                                    _cache[102] || (_cache[102] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask?.residual?.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask?.residual?.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask?.residual?.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_70, [
                                                _createElementVNode("div", _hoisted_71, [
                                                  _createElementVNode("div", _hoisted_72, [
                                                    _cache[103] || (_cache[103] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask?.residual?.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask?.residual.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask?.residual?.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_73, [
                                                    _cache[104] || (_cache[104] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 1 && _ctx.presentSubTask.appId==10003 && !_ctx.presentSubTask.hasOwnProperty('control'))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                        _createElementVNode("div", null, [
                                          _cache[119] || (_cache[119] = _createElementVNode("div", null, [
                                            _createElementVNode("div", { class: "border-b border-lightgrey" }, [
                                              _createElementVNode("p", { class: "mt-3 mb-1.5 header" }, "Risk Info")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", _hoisted_75, [
                                            _createElementVNode("div", _hoisted_76, [
                                              _cache[109] || (_cache[109] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Risk", -1)),
                                              ((_ctx.presentSubTask.TaskName||'N/A'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.presentSubTask.TaskName ||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_78, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_79, [
                                              _cache[110] || (_cache[110] = _createElementVNode("p", { class: "font-extrabold mt-3 mb-1 text-xs" }, "Priority", -1)),
                                              (_ctx.presentSubTask.priority && typeof _ctx.presentSubTask.priority === 'number')
                                                ? (_openBlock(), _createElementBlock("div", {
                                                    key: 0,
                                                    class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.colorLabelBg(_ctx.presentSubTask.riskInformation.priority)])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["text-xs", _ctx.colorLabelText(_ctx.presentSubTask.priority)])
                                                    }, _toDisplayString(_ctx.getProirityLabel(_ctx.presentSubTask.priority)), 3)
                                                  ], 2))
                                                : (_openBlock(), _createElementBlock("div", _hoisted_80, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_81, [
                                            _createElementVNode("div", _hoisted_82, [
                                              _cache[111] || (_cache[111] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Category", -1)),
                                              ((_ctx.presentSubTask.riskCategory))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_83, _toDisplayString(_ctx.presentSubTask.riskCategory||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_84, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_85, [
                                              _cache[112] || (_cache[112] = _createElementVNode("p", { class: "font-extrabold mb-1 text-xs" }, "Risk Owner", -1)),
                                              ((_ctx.presentSubTask.riskOwner))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_86, _toDisplayString(_ctx.getRiskOwnerLabel(_ctx.presentSubTask.riskOwner)||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_87, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", _hoisted_89, [
                                              _cache[113] || (_cache[113] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat Category", -1)),
                                              ((_ctx.presentSubTask.threatCategory))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_90, _toDisplayString(_ctx.presentSubTask.threatCategory||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_91, "N/A"))
                                            ]),
                                            _createElementVNode("div", _hoisted_92, [
                                              _cache[114] || (_cache[114] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Threat Source", -1)),
                                              ((_ctx.presentSubTask.threatSource))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_93, _toDisplayString(_ctx.presentSubTask.threatSource||'N/A'), 1))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_94, "N/A"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_95, [
                                            _cache[115] || (_cache[115] = _createElementVNode("p", { class: "font-extrabold mt-2 mb-1 text-xs" }, "Threat", -1)),
                                            ((_ctx.presentSubTask.threatEvent))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_96, _toDisplayString(_ctx.presentSubTask.threatEvent||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_97, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_98, [
                                            _cache[116] || (_cache[116] = _createElementVNode("label", { class: "font-extrabold mt-2 text-xs" }, "Vulnerability", -1)),
                                            ((_ctx.presentSubTask.vulnerability))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_99, _toDisplayString(_ctx.presentSubTask.vulnerability||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_100, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_101, [
                                            _cache[117] || (_cache[117] = _createElementVNode("p", { class: "font-extrabold mb-2 text-xs" }, "Risk Assessment", -1)),
                                            ((_ctx.presentSubTask.riskAssessment!=''))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_102, _toDisplayString(_ctx.presentSubTask.riskAssessment||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_103, "N/A"))
                                          ]),
                                          _createElementVNode("div", _hoisted_104, [
                                            _cache[118] || (_cache[118] = _createElementVNode("p", { class: "font-extrabold mb-2 text-xs" }, "Treatment Summary", -1)),
                                            ((_ctx.presentSubTask.treatmentType!=''))
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_105, _toDisplayString(_ctx.treatmentSummaryData(_ctx.presentSubTask.treatmentType)||'N/A'), 1))
                                              : (_openBlock(), _createElementBlock("p", _hoisted_106, "N/A"))
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          _cache[126] || (_cache[126] = _createElementVNode("h1", { class: "upperspacing" }, "Inherited Risk", -1)),
                                          _cache[127] || (_cache[127] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                          _createElementVNode("div", _hoisted_107, [
                                            _createElementVNode("div", _hoisted_108, [
                                              _createElementVNode("div", _hoisted_109, [
                                                _cache[120] || (_cache[120] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.business)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.business))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.business,1)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_110, [
                                                _cache[121] || (_cache[121] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.financial)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.financial))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.financial,2)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_111, [
                                            _createElementVNode("div", _hoisted_112, [
                                              _createElementVNode("div", _hoisted_113, [
                                                _cache[122] || (_cache[122] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.operations)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.operations))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.operations,3)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_114, [
                                                _cache[123] || (_cache[123] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.legal)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.legal))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.legal,4)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_115, [
                                            _createElementVNode("div", _hoisted_116, [
                                              _createElementVNode("div", _hoisted_117, [
                                                _cache[124] || (_cache[124] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.likelihood)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.likelihood))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.likelihood,5)||'N/A'), 3)
                                                ], 2)
                                              ]),
                                              _createElementVNode("div", _hoisted_118, [
                                                _cache[125] || (_cache[125] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.overallImpact)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.overallImpact))
                                                  }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.overallImpact,6)||'N/A'), 3)
                                                ], 2)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        (_ctx.presentSubTask.treatmentType && _ctx.presentSubTask.treatmentType!=10419 && _ctx.presentSubTask.residualRisk?.length)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                                              _cache[134] || (_cache[134] = _createElementVNode("h1", { class: "upperspacing" }, "Residual Risk", -1)),
                                              _cache[135] || (_cache[135] = _createElementVNode("div", { class: "border-b pt-1 border-solid border-lightgrey" }, null, -1)),
                                              _createElementVNode("div", _hoisted_120, [
                                                _createElementVNode("div", _hoisted_121, [
                                                  _createElementVNode("div", _hoisted_122, [
                                                    _cache[128] || (_cache[128] = _createElementVNode("label", { class: "controllabel" }, "Strategic", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.residualRisk?.[0]?.business)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.residualRisk?.[0]?.business))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.residualRisk?.[0]?.business,1)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_123, [
                                                    _cache[129] || (_cache[129] = _createElementVNode("label", { class: "controllabel" }, "Financial", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.residualRisk?.[0]?.financial)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.residualRisk?.[0]?.financial))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.residualRisk?.[0]?.financial,2)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_124, [
                                                _createElementVNode("div", _hoisted_125, [
                                                  _createElementVNode("div", _hoisted_126, [
                                                    _cache[130] || (_cache[130] = _createElementVNode("label", { class: "controllabel" }, "Operations", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.residualRisk?.[0]?.operations)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.residualRisk?.[0]?.operations))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.residualRisk?.[0]?.operations,3)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_127, [
                                                    _cache[131] || (_cache[131] = _createElementVNode("label", { class: "controllabel" }, "Compliance", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.residualRisk?.[0]?.legal)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.residualRisk?.[0]?.legal))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.residualRisk?.[0]?.legal,4)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_128, [
                                                _createElementVNode("div", _hoisted_129, [
                                                  _createElementVNode("div", _hoisted_130, [
                                                    _cache[132] || (_cache[132] = _createElementVNode("label", { class: "controllabel" }, "Likelihood", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.residualRisk?.[0]?.likelihood)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.residualRisk?.[0]?.likelihood))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.residualRisk?.[0]?.likelihood,5)||'N/A'), 3)
                                                    ], 2)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_131, [
                                                    _cache[133] || (_cache[133] = _createElementVNode("label", { class: "controllabel" }, "Overall Impact", -1)),
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-1", _ctx.colorRiskBg(_ctx.presentSubTask.riskInformation.overallImpact)])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(_ctx.colorRiskText(_ctx.presentSubTask.riskInformation.overallImpact))
                                                      }, _toDisplayString(_ctx.getLablesInfo(_ctx.presentSubTask.riskInformation.overallImpact,6)||'N/A'), 3)
                                                    ], 2)
                                                  ])
                                                ])
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_132, [...(_cache[136] || (_cache[136] = [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", { class: "border-b border-lightgrey flex justify-between" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "my-2 header" }, "Documents")
                                            ]),
                                            _createElementVNode("div", { class: "buttonposition flex justify-center items-center mb-1.5" })
                                          ])
                                        ], -1)
                                      ]))]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_133, [
                                        _createElementVNode("div", _hoisted_134, [
                                          _createElementVNode("div", _hoisted_135, [
                                            _createElementVNode("div", _hoisted_136, [
                                              _cache[137] || (_cache[137] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("p", { class: "my-1 header" }, "Files")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_137, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openLinkEvidencePopup && _ctx.openLinkEvidencePopup(...args))),
                                                  class: _normalizeClass(_ctx.isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                }, "Link Existing", 2),
                                                _createElementVNode("button", {
                                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openFilePopup('file'))),
                                                  class: _normalizeClass(_ctx.isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                }, "Attach", 2)
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_138, [
                                              (_ctx.fileEvidences.length)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_139, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileEvidences, (doc, idx) => {
                                                      return (_openBlock(), _createElementBlock("div", {
                                                        key: 'file-'+idx
                                                      }, [
                                                        _createElementVNode("div", _hoisted_140, [
                                                          _createElementVNode("a", {
                                                            href: "#",
                                                            onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                            class: "evidence-file-main"
                                                          }, [
                                                            ( _ctx.getEvidenceFileExt(doc)=='pdf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_142))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='doc')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_143))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='docx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_144))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xls')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_145))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='xlsx')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_146))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='rtf')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_147))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='txt')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_148))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='png')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_149))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_150))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='jpeg')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_151))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='csv')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_152))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='zip')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_153))
                                                              : _createCommentVNode("", true),
                                                            ( _ctx.getEvidenceFileExt(doc)=='mp4')
                                                              ? (_openBlock(), _createElementBlock("img", _hoisted_154))
                                                              : _createCommentVNode("", true),
                                                            _createElementVNode("div", _hoisted_155, [
                                                              _createElementVNode("div", _hoisted_156, [
                                                                _createElementVNode("p", {
                                                                  class: "evidence-file-name",
                                                                  title: doc.filename || doc.name
                                                                }, _toDisplayString(doc.filename || doc.name || 'N/A'), 9, _hoisted_157),
                                                                _createElementVNode("button", {
                                                                  type: "button",
                                                                  class: _normalizeClass(["evidence-file-delete", _ctx.isEvidenceAttachDisabled ? 'pointer-events-none' : '']),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentSubTask.evidences.indexOf(doc))), ["stop","prevent"])
                                                                }, [...(_cache[138] || (_cache[138] = [
                                                                  _createElementVNode("img", {
                                                                    src: _imports_12,
                                                                    alt: "Delete"
                                                                  }, null, -1)
                                                                ]))], 10, _hoisted_158)
                                                              ]),
                                                              _createElementVNode("div", _hoisted_159, [
                                                                _createElementVNode("p", _hoisted_160, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 1),
                                                                _createElementVNode("p", {
                                                                  class: "evidence-file-task",
                                                                  title: doc.taskId || 'N/A'
                                                                }, _toDisplayString(doc.taskId || 'N/A'), 9, _hoisted_161)
                                                              ])
                                                            ])
                                                          ], 8, _hoisted_141)
                                                        ])
                                                      ]))
                                                    }), 128))
                                                  ]))
                                                : (_openBlock(), _createElementBlock("p", _hoisted_162, "No files attached"))
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_163, [
                                            _createElementVNode("div", _hoisted_164, [
                                              _cache[139] || (_cache[139] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                                _createElementVNode("p", { class: "my-1 header" }, "Links")
                                              ], -1)),
                                              _createElementVNode("div", _hoisted_165, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openFilePopup('url'))),
                                                  class: _normalizeClass(_ctx.isEvidenceAttachDisabled ? 'btndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                }, "Add Link", 2)
                                              ])
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass(["evidence-links-wrap", { 'evidence-links-wrap--empty': _ctx.filteredLinkCount === 0 }])
                                            }, [
                                              _createElementVNode("div", _hoisted_166, [
                                                _createElementVNode("div", _hoisted_167, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    _createElementVNode("thead", null, [
                                                      _createElementVNode("tr", null, [
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-title resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onLinkHeaderClick('filename')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_168, [
                                                            _cache[140] || (_cache[140] = _createElementVNode("div", null, "Link Title", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'filename' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'filename')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-link resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('url')),
                                                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onLinkHeaderClick('url')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_169, [
                                                            _cache[141] || (_cache[141] = _createElementVNode("div", null, "Link", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'url' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'url')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _createElementVNode("th", {
                                                          class: "cursor-pointer evidence-links-col-date resizable-th",
                                                          style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate')),
                                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onLinkHeaderClick('evidenceDate')))
                                                        }, [
                                                          _createElementVNode("div", _hoisted_170, [
                                                            _cache[142] || (_cache[142] = _createElementVNode("div", null, "Evidence Date", -1)),
                                                            _createElementVNode("div", {
                                                              class: _normalizeClass(["sort cursor-pointer", _ctx.linkSortKey === 'evidenceDate' ? _ctx.linkSortClass : 'opacity-50'])
                                                            }, null, 2)
                                                          ]),
                                                          _createElementVNode("span", {
                                                            class: "column-resize-handle",
                                                            onMousedown: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.startLinkColumnResize($event, 'evidenceDate')), ["stop","prevent"]))
                                                          }, null, 32)
                                                        ], 4),
                                                        _cache[143] || (_cache[143] = _createElementVNode("th", { class: "evidence-links-col-action" }, null, -1))
                                                      ])
                                                    ])
                                                  ], 4)
                                                ]),
                                                _createElementVNode("div", _hoisted_171, [
                                                  _createElementVNode("table", {
                                                    class: "evidence-links-table",
                                                    style: _normalizeStyle(_ctx.linkTableResizeStyle)
                                                  }, [
                                                    (_ctx.paginatedLinkEvidences.length)
                                                      ? (_openBlock(), _createElementBlock("tbody", _hoisted_172, [
                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paginatedLinkEvidences, (doc, idx) => {
                                                            return (_openBlock(), _createElementBlock("tr", {
                                                              key: 'link-'+idx,
                                                              class: "rowHeight evidence-links-row"
                                                            }, [
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-title",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('filename')),
                                                                title: doc.filename || doc.name
                                                              }, [
                                                                _createElementVNode("div", _hoisted_174, _toDisplayString(doc.filename || doc.name || 'N/A'), 1)
                                                              ], 12, _hoisted_173),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-link",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('url'))
                                                              }, [
                                                                _createElementVNode("div", _hoisted_175, [
                                                                  _createElementVNode("a", {
                                                                    href: "#",
                                                                    class: "text-primary evidence-link-anchor cursor-pointer",
                                                                    onClick: _withModifiers(($event: any) => (_ctx.openEvidenceFile(doc)), ["prevent"]),
                                                                    title: doc.url
                                                                  }, _toDisplayString(doc.url), 9, _hoisted_176)
                                                                ])
                                                              ], 4),
                                                              _createElementVNode("td", {
                                                                class: "evidence-links-col-date",
                                                                style: _normalizeStyle(_ctx.linkColumnStyle('evidenceDate'))
                                                              }, _toDisplayString(doc.evidenceDate ? _ctx.formatFileAttachedTime(doc.evidenceDate) : 'N/A'), 5),
                                                              _createElementVNode("td", _hoisted_177, [
                                                                _createElementVNode("button", {
                                                                  type: "button",
                                                                  class: _normalizeClass(["evidence-links-delete", _ctx.isEvidenceAttachDisabled ? 'pointer-events-none' : '']),
                                                                  onClick: _withModifiers(($event: any) => (_ctx.openDeleteEvidenceConfirm(_ctx.presentSubTask.evidences.indexOf(doc))), ["stop","prevent"])
                                                                }, [...(_cache[144] || (_cache[144] = [
                                                                  _createElementVNode("img", {
                                                                    src: _imports_12,
                                                                    alt: "Delete",
                                                                    class: "h-5 w-5"
                                                                  }, null, -1)
                                                                ]))], 10, _hoisted_178)
                                                              ])
                                                            ]))
                                                          }), 128))
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("tbody", _hoisted_179, [...(_cache[145] || (_cache[145] = [
                                                          _createElementVNode("tr", null, [
                                                            _createElementVNode("td", {
                                                              class: "evidence-links-empty",
                                                              colspan: "4"
                                                            }, [
                                                              _createElementVNode("div", { class: "flex justify-center" }, [
                                                                _createElementVNode("p", { class: "text-xs font-normal" }, "No Records Found")
                                                              ])
                                                            ])
                                                          ], -1)
                                                        ]))]))
                                                  ], 4)
                                                ])
                                              ]),
                                              (_ctx.filteredLinkCount > 0)
                                                ? (_openBlock(), _createBlock(_component_pagination, {
                                                    key: 0,
                                                    dynamicPagination: _ctx.filteredLinkCount,
                                                    sortedData: _ctx.sortedLinkEvidences,
                                                    onCurrentPageUpdate: _ctx.onLinkPaginationUpdate
                                                  }, null, 8, ["dynamicPagination", "sortedData", "onCurrentPageUpdate"]))
                                                : _createCommentVNode("", true)
                                            ], 2)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 5)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_180, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_181, [
                                            _cache[148] || (_cache[148] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "my-2.5 header" }, "Comments")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_182, [
                                                (!_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 0,
                                                      class: "btnprimary flex taskEditButtons",
                                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.sortComments()))
                                                    }, [...(_cache[146] || (_cache[146] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_13,
                                                        class: "h-3 mr-2"
                                                      }, null, -1),
                                                      _createTextVNode(" Newest ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true),
                                                (_ctx.oldComments)
                                                  ? (_openBlock(), _createElementBlock("button", {
                                                      key: 1,
                                                      class: "btnprimary flex taskEditButtons",
                                                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.sortComments()))
                                                    }, [...(_cache[147] || (_cache[147] = [
                                                      _createElementVNode("img", {
                                                        src: _imports_13,
                                                        class: "h-3 mr-2 rotate-180"
                                                      }, null, -1),
                                                      _createTextVNode(" Oldest ", -1)
                                                    ]))]))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_183, [
                                              _createElementVNode("div", _hoisted_184, [
                                                (_ctx.TaskDetailsDropDown.taskStatus!=10403&&_ctx.TaskDetailsDropDown.taskStatus!=10401&&_ctx.TaskDetailsDropDown.taskStatus!=10420 && _ctx.TaskDetailsDropDown.taskStatus!=10423 && _ctx.TaskDetailsDropDown.taskStatus!=10410 &&_ctx.presentSubTask.statusCode != 10418&& !_ctx.isAddDisabled(10302))
                                                  ? (_openBlock(), _createBlock(_component_commentsEditor, { key: 0 }))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            (Object.keys(_ctx.presentSubTask).includes('comments'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentSubTask.comments, (obj, index) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      class: "border border-lightgrey mt-2 rounded-sm flex flex-row p-2",
                                                      key: index
                                                    }, [
                                                      _createElementVNode("div", _hoisted_186, _toDisplayString(_ctx.extractInitials((obj.name) )), 1),
                                                      _createElementVNode("div", _hoisted_187, [
                                                        _createElementVNode("div", _hoisted_188, _toDisplayString((obj.name)), 1),
                                                        _createElementVNode("div", _hoisted_189, _toDisplayString(_ctx.formatTime( obj.createdAt )), 1)
                                                      ]),
                                                      _createElementVNode("div", _hoisted_190, [
                                                        _createVNode(_component_safeHtml, {
                                                          content: obj.comment
                                                        }, null, 8, ["content"])
                                                      ])
                                                    ]))
                                                  }), 128))
                                                ]))
                                              : _createCommentVNode("", true)
                                          ])
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 4)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                        _createElementVNode("div", _hoisted_192, [
                                          _cache[149] || (_cache[149] = _createElementVNode("div", { class: "flex items-center justify-center" }, [
                                            _createElementVNode("div", null, [
                                              _createElementVNode("p", { class: "header" }, "Approvals")
                                            ])
                                          ], -1)),
                                          _createElementVNode("div", null, [
                                            _createElementVNode("div", _hoisted_193, [
                                              _createElementVNode("div", _hoisted_194, [
                                                _createElementVNode("button", {
                                                  onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.openApprovalpopup())),
                                                  class: _normalizeClass(_ctx.presentSubTask.statusCode==10403 || _ctx.presentSubTask.statusCode==10421 || _ctx.presentSubTask.statusCode==10420||_ctx.presentSubTask.statusCode==10423||_ctx.presentSubTask.statusCode==10410|| _ctx.presentSubTask.statusCode == 10418|| _ctx.isAddApprovalDisabled(10302)?'approvalbtndisabled pointer-events-none paddingForAttachButton' : 'btnprimary flex justify-center taskEditButtons')
                                                }, " Send Approval ", 2)
                                              ])
                                            ])
                                          ])
                                        ]),
                                        _createElementVNode("div", null, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.presentSubTask.approvals, (approval, number) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: number,
                                              class: "bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full"
                                            }, [
                                              (approval.createdBy != undefined && !approval.updatedBy)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_195, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                : _createCommentVNode("", true),
                                              (approval.createdBy != undefined && !approval.updatedBy)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_196, _toDisplayString((approval.name)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedBy != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_197, _toDisplayString(_ctx.extractInitials((approval.name))), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedBy != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_198, _toDisplayString((approval.name)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.statusCode == 10401)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_199, _toDisplayString(' Requested an approval ')))
                                                : (approval.statusCode == 10410)
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_200, _toDisplayString(' Rejected an approval ')))
                                                  : (approval.statusCode == 10403)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_201, _toDisplayString(' Approved an approval ')))
                                                    : _createCommentVNode("", true),
                                              (approval.createdAt != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_202, _toDisplayString(_ctx.formatTime(approval.createdAt)), 1))
                                                : _createCommentVNode("", true),
                                              (approval.updatedAt != undefined)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_203, _toDisplayString(_ctx.formatTime(approval.updatedAt)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true),
                                  (tab.id == 6)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_204, [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("div", _hoisted_205, [
                                            _cache[152] || (_cache[152] = _createElementVNode("div", { class: "flex items-center justify-between" }, [
                                              _createElementVNode("div", null, [
                                                _createElementVNode("p", { class: "header" }, "History")
                                              ])
                                            ], -1)),
                                            _createElementVNode("div", null, [
                                              _createElementVNode("div", _hoisted_206, [
                                                _createElementVNode("div", _hoisted_207, [
                                                  (!_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 0,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, [...(_cache[150] || (_cache[150] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_13,
                                                          class: "h-3 mr-2"
                                                        }, null, -1),
                                                        _createTextVNode(" Newest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true),
                                                  (_ctx.newHistory)
                                                    ? (_openBlock(), _createElementBlock("button", {
                                                        key: 1,
                                                        class: "btnprimary flex taskEditButtons",
                                                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.sortWorkLog()))
                                                      }, [...(_cache[151] || (_cache[151] = [
                                                        _createElementVNode("img", {
                                                          src: _imports_13,
                                                          class: "h-3 mr-2 rotate-180"
                                                        }, null, -1),
                                                        _createTextVNode(" Oldest ", -1)
                                                      ]))]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ])
                                          ]),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workLogObject.taskHistory, (work, historyIndex) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                              key: historyIndex + '-' + (work.updatedAt || work.createdAt || ''),
                                              class: "bg-white p-4 mb-0.5 border-lightgrey border-b w-full"
                                            }, [
                                              _createElementVNode("div", _hoisted_208, [
                                                (Object.keys(work).includes('createdBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_209, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                  : _createCommentVNode("", true),
                                                (Object.keys(work).includes('updatedBy'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_210, _toDisplayString(_ctx.extractInitials((work.name))), 1))
                                                  : _createCommentVNode("", true),
                                                _createElementVNode("div", _hoisted_211, [
                                                  _createElementVNode("div", _hoisted_212, [
                                                    (Object.keys(work).includes('createdBy'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_213, _toDisplayString((work.name)), 1))
                                                      : (Object.keys(work).includes('updatedBy'))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_214, _toDisplayString((work.name)), 1))
                                                        : _createCommentVNode("", true),
                                                    (work.actionEntity == 10301)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_215, _toDisplayString('Created the Task on')))
                                                      : (work.statusCode != undefined && work.statusCode == 10418)
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_216, _toDisplayString('Terminated the Task on')))
                                                        : (work.actionEntity == 10302)
                                                          ? (_openBlock(), _createElementBlock("p", _hoisted_217, _toDisplayString('Updated the Task on')))
                                                          : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('createdAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_218, _toDisplayString(_ctx.formatTime(work.createdAt)), 1))
                                                      : _createCommentVNode("", true),
                                                    (Object.keys(work).includes('updatedAt'))
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_219, _toDisplayString(_ctx.formatTime(work.updatedAt)), 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  (Object.keys(work).includes('additionalInfo'))
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                        (Object.keys(work.additionalInfo).includes('comment'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_221, [
                                                              _cache[153] || (_cache[153] = _createElementVNode("p", { class: "font-semibold text-xs widthForCommentBox" }, _toDisplayString('Comment :'), -1)),
                                                              _createElementVNode("p", _hoisted_222, [
                                                                _createVNode(_component_safeHtml, {
                                                                  content: work.additionalInfo.comment
                                                                }, null, 8, ["content"])
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('dateId'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_223, [
                                                              _cache[154] || (_cache[154] = _createElementVNode("p", { class: "font-normal text-xs" }, _toDisplayString('Updated the '), -1)),
                                                              (work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_224, _toDisplayString(' Completion Date from')))
                                                                : (work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_225, _toDisplayString(' Start Date from')))
                                                                  : (work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_226, _toDisplayString(' dueDate from')))
                                                                    : _createCommentVNode("", true),
                                                              (work.additionalInfo.previousCompletionDate!='' && work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_227, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousCompletionDate)), 1))
                                                                : (work.additionalInfo.previousStartDate!='' && work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_228, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousStartDate)), 1))
                                                                  : (work.additionalInfo.previousEndDate!='' && work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_229, _toDisplayString(_ctx.formatDate(work.additionalInfo?.previousEndDate)), 1))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_230, "N/A")),
                                                              _cache[155] || (_cache[155] = _createElementVNode("p", { class: "mx-2 font-normal text-xs" }, _toDisplayString('to'), -1)),
                                                              (work.additionalInfo.updatedCompletionDate!=''&& work.additionalInfo.dateId==20606)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_231, _toDisplayString(_ctx.formatDate(work.additionalInfo.updatedCompletionDate)), 1))
                                                                : (work.additionalInfo.updatedStartDate!=''&& work.additionalInfo.dateId==20604)
                                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_232, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedStartDate)), 1))
                                                                  : (work.additionalInfo.updatedEndDate!='' && work.additionalInfo.dateId==20605)
                                                                    ? (_openBlock(), _createElementBlock("p", _hoisted_233, _toDisplayString(_ctx.formatDate(work.additionalInfo?.updatedEndDate)), 1))
                                                                    : (_openBlock(), _createElementBlock("p", _hoisted_234, "N/A"))
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceTitles') || Object.keys(work.additionalInfo).includes('linkedEvidenceTaskIds'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_235, [
                                                              _cache[156] || (_cache[156] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Linked the Evidence -'), -1)),
                                                              _createElementVNode("p", _hoisted_236, _toDisplayString(work.additionalInfo.linkedEvidenceTitles || work.additionalInfo.linkedEvidenceTaskIds), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('linkedEvidenceDates'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_237, [
                                                              _cache[157] || (_cache[157] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_238, _toDisplayString(work.additionalInfo.linkedEvidenceDates || 'N/A'), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('filename'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_239, [
                                                              _createElementVNode("p", _hoisted_240, _toDisplayString(work.additionalInfo.removed ? 'Deleted the Evidence -' : 'Uploaded the Evidence -'), 1),
                                                              _createElementVNode("p", _hoisted_241, _toDisplayString(work.additionalInfo.filename), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('evidenceDate'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_242, [
                                                              _cache[158] || (_cache[158] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Evidence Date -'), -1)),
                                                              _createElementVNode("p", _hoisted_243, _toDisplayString(_ctx.formatDate(work.additionalInfo.evidenceDate)||'N/A'), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('assignee'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_244, [
                                                              _cache[159] || (_cache[159] = _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Assigned the Task To -'), -1)),
                                                              _createElementVNode("p", _hoisted_245, _toDisplayString((work.additionalInfo.name)), 1)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('approver'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_246, [
                                                              (Object.keys(work.additionalInfo).includes('action') && work.additionalInfo.action == 10301)
                                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                                    _cache[160] || (_cache[160] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Requested approval from -", -1)),
                                                                    _createElementVNode("p", _hoisted_247, _toDisplayString(work.additionalInfo.name), 1)
                                                                  ], 64))
                                                                : (!Object.keys(work).includes('action') && !Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode != 10410)
                                                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                      _cache[161] || (_cache[161] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Request approved By -", -1)),
                                                                      _createElementVNode("p", _hoisted_248, _toDisplayString(work.additionalInfo.name), 1)
                                                                    ], 64))
                                                                  : (!Object.keys(work).includes('action') && Object.keys(work).includes('additionalInfo') && work.additionalInfo.statusCode != undefined && work.additionalInfo.statusCode == 10410)
                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_249, [
                                                                        _createElementVNode("div", _hoisted_250, [
                                                                          _cache[162] || (_cache[162] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Request Rejected By -", -1)),
                                                                          _createElementVNode("p", _hoisted_251, _toDisplayString(work.additionalInfo.name), 1)
                                                                        ]),
                                                                        (work.additionalInfo.justification != undefined)
                                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_252, [
                                                                              _cache[163] || (_cache[163] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Justification :", -1)),
                                                                              _createElementVNode("p", _hoisted_253, _toDisplayString(work.additionalInfo.justification), 1)
                                                                            ]))
                                                                          : _createCommentVNode("", true)
                                                                      ]))
                                                                    : _createCommentVNode("", true)
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (Object.keys(work.additionalInfo).includes('previousStatus'))
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_254, [
                                                              _cache[165] || (_cache[165] = _createElementVNode("div", null, [
                                                                _createElementVNode("p", { class: "font-semibold text-xs" }, _toDisplayString('Updated The Status :'))
                                                              ], -1)),
                                                              _createElementVNode("div", _hoisted_255, [
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.previousStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.previousStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.previousStatus)), 3)
                                                                ], 2),
                                                                _cache[164] || (_cache[164] = _createElementVNode("div", { class: "mx-4 flex items-center" }, [
                                                                  _createElementVNode("img", { src: _imports_14 })
                                                                ], -1)),
                                                                _createElementVNode("div", {
                                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 labelWidth", _ctx.colorTemplateBg(work.additionalInfo.updatedStatus)])
                                                                }, [
                                                                  _createElementVNode("div", {
                                                                    class: _normalizeClass(_ctx.colorTemplateText(work.additionalInfo.updatedStatus))
                                                                  }, _toDisplayString(_ctx.getStatusLabel(work.additionalInfo.updatedStatus)), 3)
                                                                ], 2)
                                                              ])
                                                            ]))
                                                          : _createCommentVNode("", true),
                                                        (work.additionalInfo.justification != undefined && work.additionalInfo.justification != '')
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_256, [
                                                              _cache[166] || (_cache[166] = _createElementVNode("p", { class: "font-semibold text-xs" }, "Justification :", -1)),
                                                              _createElementVNode("p", _hoisted_257, _toDisplayString(work.additionalInfo.justification), 1)
                                                            ]))
                                                          : _createCommentVNode("", true)
                                                      ]))
                                                    : _createCommentVNode("", true)
                                                ])
                                              ])
                                            ]))
                                          }), 128))
                                        ])
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              _createElementVNode("div", _hoisted_258, [
                _createElementVNode("div", _hoisted_259, [
                  _cache[186] || (_cache[186] = _createElementVNode("div", { class: "pb-2 border-b border-lightgrey" }, [
                    _createElementVNode("h1", null, "Task Details")
                  ], -1)),
                  (_ctx.dotsLoader == true)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_260, [
                        _createElementVNode("div", _hoisted_261, [
                          _createVNode(_component_dotsloader)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_262, [
                        _createElementVNode("div", _hoisted_263, [
                          _cache[167] || (_cache[167] = _createElementVNode("label", { class: "controllabel" }, "Task Status", -1)),
                          ((_ctx.presentSubTask.statusCode == 10403))
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.changeBackground()),
                                  onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                }, _toDisplayString(_ctx.subTaskStatuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                              ], 2))
                            : ((_ctx.presentSubTask.statusCode == 10423))
                              ? (_openBlock(), _createElementBlock("div", {
                                  key: 1,
                                  class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                }, [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(_ctx.changeBackground()),
                                    onChange: _cache[18] || (_cache[18] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                  }, _toDisplayString(_ctx.subTaskStatuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                                ], 2))
                              : ((_ctx.presentSubTask.statusCode == 10410))
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                  }, [
                                    _createElementVNode("div", {
                                      class: _normalizeClass(_ctx.changeBackground()),
                                      onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                    }, _toDisplayString(_ctx.subTaskStatuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                                  ], 2))
                                : ((_ctx.presentSubTask.statusCode == 10420 ))
                                  ? (_openBlock(), _createElementBlock("div", {
                                      key: 3,
                                      class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                    }, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(_ctx.changeBackground()),
                                        onChange: _cache[20] || (_cache[20] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                      }, _toDisplayString(_ctx.statuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                                    ], 2))
                                  : ((_ctx.presentSubTask.statusCode == 10418 ))
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 4,
                                        class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                      }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(_ctx.changeBackground()),
                                          onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                        }, _toDisplayString(_ctx.statuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                                      ], 2))
                                    : ((_ctx.presentSubTask.statusCode == 10421 ))
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 5,
                                          class: _normalizeClass([_ctx.changeBackground(), "taskstatusboxstyling cursor-pointer"])
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(_ctx.changeBackground()),
                                            onChange: _cache[22] || (_cache[22] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus)))
                                          }, _toDisplayString(_ctx.statuses.find((data)=>{
															return data.id == _ctx.presentSubTask.statusCode
														})?.label||'N/A'), 35)
                                        ], 2))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_264, [
                                          ((_ctx.presentSubTask.statusCode != 10402))
                                            ? (_openBlock(), _createBlock(_component_Select, {
                                                key: 0,
                                                modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                                options: _ctx.taskStatuses,
                                                disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.isAddDisabled(10302),
                                                onChange: _cache[24] || (_cache[24] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                                optionLabel: "label",
                                                optionValue: "id",
                                                class: _normalizeClass(["custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey", _ctx.changeBackground()])
                                              }, null, 8, ["modelValue", "options", "disabled", "class"]))
                                            : (_openBlock(), _createBlock(_component_Select, {
                                                key: 1,
                                                modelValue: _ctx.TaskDetailsDropDown.taskStatus,
                                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.TaskDetailsDropDown.taskStatus) = $event)),
                                                options: _ctx.subTaskStatuses,
                                                disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.isAddDisabled(10302),
                                                onChange: _cache[26] || (_cache[26] = ($event: any) => (_ctx.updateTaskStatus(_ctx.TaskDetailsDropDown.taskStatus))),
                                                optionLabel: "label",
                                                optionValue: "id",
                                                class: _normalizeClass(["custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey", _ctx.changeBackground()])
                                              }, null, 8, ["modelValue", "options", "disabled", "class"]))
                                        ]))
                        ]),
                        _createElementVNode("div", _hoisted_265, [
                          _createElementVNode("div", null, [
                            _cache[169] || (_cache[169] = _createElementVNode("label", { class: "controllabel" }, "Assigned To", -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.presentSubTask.assignee,
                                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.presentSubTask.assignee) = $event)),
                                suggestions: _ctx.userOptions,
                                onComplete: _ctx.asyncFind,
                                onItemSelect: _cache[28] || (_cache[28] = ($event: any) => (_ctx.updateAssignedMember(_ctx.presentSubTask.assignee))),
                                disabled: _ctx.presentSubTask.statusCode == 10403||_ctx.presentSubTask.statusCode == 10420 || _ctx.presentSubTask.statusCode==10423|| _ctx.presentSubTask.statusCode==10410|| _ctx.presentSubTask.statusCode == 10418 ||_ctx.isAddDisabled(10302),
                                optionLabel: "label",
                                optionValue: "value",
                                placeholder: "Assigned-To",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling mt-2 custom-multiselect userSelect", {
															'has-options': _ctx.userOptions && _ctx.userOptions.length > 0,
															'no-options': !_ctx.userOptions.length &&  _ctx.searchValue !== '',
														}])
                              }, {
                                empty: _withCtx(() => [...(_cache[168] || (_cache[168] = [
                                  _createElementVNode("div", { class: "text-sm" }, [
                                    _createElementVNode("span", null, "No Members Found")
                                  ], -1)
                                ]))]),
                                _: 1
                              }, 8, ["modelValue", "suggestions", "onComplete", "disabled", "class"])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_266, [
                          _cache[170] || (_cache[170] = _createElementVNode("label", { class: "controllabel mb-2" }, "Created By", -1)),
                          _cache[171] || (_cache[171] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", _hoisted_267, _toDisplayString(_ctx.getPersonName(_ctx.presentSubTask.createdBy,_ctx.presentSubTask.createdPersonName)), 1)
                        ]),
                        ((_ctx.presentSubTask.appId && _ctx.presentSubTask.appId==10003)|| _ctx.presentSubTask.treatmentType!=undefined)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_268, [
                              _cache[172] || (_cache[172] = _createElementVNode("label", { class: "controllabel mb-2" }, "Treatment Type", -1)),
                              _cache[173] || (_cache[173] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("div", {
                                class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2 mb-3", _ctx.treatmentTypeBgColor(_ctx.presentSubTask.treatmentType)])
                              }, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-xs", _ctx.treatmentTypeTextColor(_ctx.presentSubTask.treatmentType)])
                                }, _toDisplayString(_ctx.presentTask(_ctx.presentSubTask.treatmentType)||'N/A'), 3)
                              ], 2)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_269, [
                          _createElementVNode("div", null, [
                            _cache[174] || (_cache[174] = _createElementVNode("label", { class: "controllabel" }, "Start Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.presentSubTask.startDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403||_ctx.TaskDetailsDropDown.taskStatus==10423||_ctx.TaskDetailsDropDown.taskStatus==10410|| _ctx.presentSubTask.statusCode == 10418,
                              max: _ctx.presentSubTask.dueDate,
                              onChange: _cache[31] || (_cache[31] = ($event: any) => (_ctx.updateDate(_ctx.presentSubTask.startDate,20604)))
                            }, null, 40, _hoisted_270), [
                              [_vModelText, _ctx.presentSubTask.startDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_271, [
                          _createElementVNode("div", null, [
                            _cache[175] || (_cache[175] = _createElementVNode("label", { class: "controllabel" }, "Due Date", -1)),
                            _withDirectives(_createElementVNode("input", {
                              type: "date",
                              "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.presentSubTask.dueDate) = $event)),
                              class: "mt-2 w-full stylingForInputboxstylingForSelectAtPopup",
                              onFocus: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403||_ctx.TaskDetailsDropDown.taskStatus==10423||_ctx.TaskDetailsDropDown.taskStatus==10410|| _ctx.presentSubTask.statusCode == 10418,
                              min: _ctx.presentSubTask.startDate,
                              onChange: _cache[34] || (_cache[34] = ($event: any) => (_ctx.updateDate(_ctx.presentSubTask.dueDate,20605)))
                            }, null, 40, _hoisted_272), [
                              [_vModelText, _ctx.presentSubTask.dueDate]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_273, [
                          _cache[176] || (_cache[176] = _createElementVNode("label", { class: "controllabel mb-2" }, "Completion Date", -1)),
                          _cache[177] || (_cache[177] = _createElementVNode("br", null, null, -1)),
                          _withDirectives(_createElementVNode("input", {
                            type: "date",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.presentSubTask.completedAt) = $event)),
                            class: _normalizeClass(["mt-2", {'inputboxstylingForSelectAtPopup': _ctx.presentSubTask.startDate === '','stylingForInputboxstylingForSelectAtPopup': _ctx.presentSubTask.startDate !== ''}]),
                            onFocus: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                            min: _ctx.presentSubTask.startDate,
                            placeholder: "Select Date",
                            disabled: _ctx.TaskDetailsDropDown.taskStatus ==10403||_ctx.TaskDetailsDropDown.taskStatus==10423||_ctx.TaskDetailsDropDown.taskStatus==10410|| _ctx.presentSubTask.statusCode == 10418,
                            onChange: _cache[37] || (_cache[37] = ($event: any) => (_ctx.updateCompletionDate(_ctx.presentSubTask.completedAt)))
                          }, null, 42, _hoisted_274), [
                            [_vModelText, _ctx.presentSubTask.completedAt]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_275, [
                          _cache[178] || (_cache[178] = _createElementVNode("label", { class: "controllabel mb-2" }, "Team", -1)),
                          _cache[179] || (_cache[179] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getUserteamName(_ctx.presentSubTask.departments)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_276, [
                          _cache[180] || (_cache[180] = _createElementVNode("label", { class: "controllabel mb-2" }, "Location", -1)),
                          _cache[181] || (_cache[181] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getLocationName(_ctx.presentSubTask.entity)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_277, [
                          _cache[182] || (_cache[182] = _createElementVNode("label", { class: "controllabel mb-2" }, "Tier", -1)),
                          _cache[183] || (_cache[183] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getTargetTitle(_ctx.presentSubTask)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_278, [
                          _cache[184] || (_cache[184] = _createElementVNode("label", { class: "controllabel mb-2" }, "Scope", -1)),
                          _cache[185] || (_cache[185] = _createElementVNode("br", null, null, -1)),
                          _createElementVNode("div", null, _toDisplayString(_ctx.getTargetInfo(_ctx.presentSubTask)), 1)
                        ])
                      ]))
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    (_ctx.showDeleteEvidenceConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_279, [
          _createElementVNode("div", {
            class: "evidence-delete-backdrop",
            onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
          }),
          _createElementVNode("div", _hoisted_280, [
            _cache[187] || (_cache[187] = _createElementVNode("div", { class: "evidence-delete-dialog-title" }, [
              _createElementVNode("div", { class: "evidence-delete-warning" }, [
                _createElementVNode("img", {
                  src: _imports_15,
                  class: "evidence-delete-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Delete Evidence")
            ], -1)),
            _cache[188] || (_cache[188] = _createElementVNode("p", { class: "evidence-delete-dialog-message" }, "Are you sure you want to delete this evidence?", -1)),
            _createElementVNode("div", _hoisted_281, [
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-cancel",
                onClick: _cache[39] || (_cache[39] = 
//@ts-ignore
(...args) => (_ctx.cancelDeleteEvidence && _ctx.cancelDeleteEvidence(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: "evidence-delete-ok",
                onClick: _cache[40] || (_cache[40] = 
//@ts-ignore
(...args) => (_ctx.confirmDeleteEvidence && _ctx.confirmDeleteEvidence(...args)))
              }, "OK")
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.importpopUp)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 2,
          popUp: _ctx.importpopUp
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_282, [
              _createElementVNode("div", _hoisted_283, [
                _createElementVNode("div", _hoisted_284, [
                  _createElementVNode("div", _hoisted_285, [
                    _createElementVNode("h1", null, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Attach Link' : 'Attach File'), 1),
                    _createElementVNode("button", {
                      class: "p-1 ml-auto float-right text-3xl leading-none font-semibold outline-none focus:outline-none",
                      onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onCancelIcon()))
                    }, [...(_cache[189] || (_cache[189] = [
                      _createElementVNode("img", {
                        src: _imports_16,
                        class: "h-5 w-5 cursor-pointer"
                      }, null, -1)
                    ]))])
                  ]),
                  _cache[197] || (_cache[197] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey ml-4 mr-4" }, null, -1)),
                  _createElementVNode("div", _hoisted_286, [
                    _createElementVNode("div", _hoisted_287, [
                      _createElementVNode("div", _hoisted_288, [
                        _createElementVNode("div", _hoisted_289, [
                          _createElementVNode("div", null, [
                            _createElementVNode("label", _hoisted_290, _toDisplayString(_ctx.evidenceAttachMode === 'url' ? 'Title' : 'File Name'), 1),
                            (_ctx.evidenceAttachMode === 'url')
                              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 0,
                                  class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                                  type: "text",
                                  "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                  placeholder: "Evidence title",
                                  onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                                }, null, 34)), [
                                  [
                                    _vModelText,
                                    _ctx.inputFileName,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              : _withDirectives((_openBlock(), _createElementBlock("input", {
                                  key: 1,
                                  class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.inputFileName.$error }]),
                                  type: "text",
                                  "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.inputFileName) = $event)),
                                  placeholder: "Filename",
                                  onInput: _cache[45] || (_cache[45] = ($event: any) => (_ctx.v$.inputFileName.$touch()))
                                }, null, 34)), [
                                  [
                                    _vModelText,
                                    _ctx.inputFileName,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                            (_ctx.v$.inputFileName.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_291, [
                                  (_ctx.v$.inputFileName.required.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_292, "Required"))
                                    : (_ctx.v$.inputFileName.restrictCharacters50 && _ctx.v$.inputFileName.restrictCharacters50.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_293, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          (_ctx.evidenceAttachMode === 'file')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_294, [
                                _cache[192] || (_cache[192] = _createElementVNode("label", { class: "controllabel" }, "Attachment", -1)),
                                _createElementVNode("input", {
                                  type: "file",
                                  ref: "fileInput",
                                  class: "hidden",
                                  id: "upload",
                                  onChange: _cache[46] || (_cache[46] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args)))
                                }, null, 544),
                                _createElementVNode("div", {
                                  class: _normalizeClass(["w-auto rounded-sm mt-2 p-8 flex flex-col items-center justify-center text-center transition border-2 border-dashed border-lightgrey bg-whitegrey", {
                    'is-invalid': _ctx.v$.fileToUpload.$error || _ctx.pdfValidation,
                    'border-primary': _ctx.isDragOver
                  }]),
                                  onDragenter: _cache[48] || (_cache[48] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                  onDragover: _cache[49] || (_cache[49] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args)), ["prevent"])),
                                  onDragleave: _cache[50] || (_cache[50] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args)), ["prevent"])),
                                  onDrop: _cache[51] || (_cache[51] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onFileDrop && _ctx.onFileDrop(...args)), ["prevent"]))
                                }, [
                                  _cache[191] || (_cache[191] = _createElementVNode("img", {
                                    src: _imports_17,
                                    class: "h-10 w-10 mb-3",
                                    alt: "Upload file"
                                  }, null, -1)),
                                  (_ctx.fileName === '')
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_295, " Drag and drop your file here "))
                                    : (_openBlock(), _createElementBlock("p", _hoisted_296, _toDisplayString(_ctx.fileName), 1)),
                                  _createElementVNode("div", _hoisted_297, [
                                    _cache[190] || (_cache[190] = _createElementVNode("label", {
                                      for: "upload",
                                      class: "cursor-pointer"
                                    }, [
                                      _createElementVNode("span", { class: "browseBtnprimary text-xs gap-1" }, [
                                        _createElementVNode("img", {
                                          src: _imports_18,
                                          class: "h-4 w-4",
                                          alt: ""
                                        }),
                                        _createTextVNode(" Browse ")
                                      ])
                                    ], -1)),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: _normalizeClass(["text-xs gap-1", _ctx.fileName === '' ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
                                      disabled: _ctx.fileName === '',
                                      onClick: _cache[47] || (_cache[47] = 
//@ts-ignore
(...args) => (_ctx.clearSelectedFile && _ctx.clearSelectedFile(...args)))
                                    }, " Cancel ", 10, _hoisted_298)
                                  ])
                                ], 34),
                                _createElementVNode("div", _hoisted_299, [
                                  (_ctx.v$.fileToUpload.$invalid && !_ctx.pdfValidation && (_ctx.v$.fileToUpload.$error || _ctx.pdfValidation))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_300, " File upload is required "))
                                    : _createCommentVNode("", true),
                                  (_ctx.pdfValidation && !_ctx.v$.fileToUpload.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_301, " This File Format is not Supported "))
                                    : _createCommentVNode("", true)
                                ]),
                                _cache[193] || (_cache[193] = _createElementVNode("div", { class: "mt-2 flex flex-col items-center" }, [
                                  _createElementVNode("p", { class: "text-xs text-placeholdergray" }, " Accepted Formats: PDF, JPG, PNG, ZIP, TXT, XLS, DOC, MP4 "),
                                  _createElementVNode("p", { class: "text-xs text-placeholdergray mt-1" }, " Maximum File Size: 50 MB ")
                                ], -1))
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.evidenceAttachMode === 'url')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_302, [
                                _cache[194] || (_cache[194] = _createElementVNode("label", { class: "controllabel" }, "URL", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.evidenceUrl.$error }]),
                                  type: "url",
                                  "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.evidenceUrl) = $event)),
                                  placeholder: "URL",
                                  onInput: _cache[53] || (_cache[53] = ($event: any) => (_ctx.v$.evidenceUrl.$touch()))
                                }, null, 34), [
                                  [
                                    _vModelText,
                                    _ctx.evidenceUrl,
                                    void 0,
                                    { trim: true }
                                  ]
                                ]),
                                (_ctx.v$.evidenceUrl.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_303, [
                                      (_ctx.v$.evidenceUrl.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_304, "Required"))
                                        : (_ctx.v$.evidenceUrl.httpUrl.$invalid)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_305, "URL must use http or https"))
                                          : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_306, [
                            _cache[195] || (_cache[195] = _createElementVNode("label", { class: "controllabel" }, _toDisplayString('Evidence Date'), -1)),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.evidenceDate) = $event)),
                              type: "date",
                              class: _normalizeClass(["mt-2 w-full inputboxstylingForSelectAtPopup", {
									'inputboxstylingForSelectAtPopup': _ctx.evidenceDate === '',
									'stylingForInputboxstylingForSelectAtPopup': _ctx.evidenceDate !== '',
									'is-invalid':_ctx.v$.evidenceDate.$error
									}]),
                              onFocus: _cache[55] || (_cache[55] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                              style: {"height":"28px"},
                              onkeydown: "return false",
                              placeholder: "Select Date",
                              max: _ctx.todayDate
                            }, null, 42, _hoisted_307), [
                              [_vModelText, _ctx.evidenceDate]
                            ]),
                            (_ctx.v$.evidenceDate.$error)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_308, [
                                  (_ctx.v$.evidenceDate.$invalid)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_309, _toDisplayString('Evidence date is required')))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _cache[196] || (_cache[196] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey" }, null, -1)),
                        _createElementVNode("div", _hoisted_310, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["btnprimary", _ctx.isEvidenceSaveDisabled ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                            onClick: _cache[56] || (_cache[56] = 
//@ts-ignore
(...args) => (_ctx.onEvidenceSave && _ctx.onEvidenceSave(...args)))
                          }, "Save", 2)
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.linkEvidencePopup)
      ? (_openBlock(), _createElementBlock("div", _hoisted_311, [
          _createElementVNode("div", {
            class: "link-existing-backdrop",
            onClick: _cache[57] || (_cache[57] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
          }),
          _createElementVNode("div", _hoisted_312, [
            _cache[207] || (_cache[207] = _createElementVNode("div", { class: "link-existing-title" }, [
              _createElementVNode("span", {
                class: "link-existing-warning",
                "aria-hidden": "true"
              }, [
                _createElementVNode("img", {
                  src: _imports_15,
                  class: "link-existing-warning-icon",
                  alt: ""
                })
              ]),
              _createElementVNode("span", null, "Link Existing Evidence")
            ], -1)),
            _cache[208] || (_cache[208] = _createElementVNode("p", { class: "link-existing-message" }, "Select evidence from the past year listed below.", -1)),
            _createElementVNode("div", _hoisted_313, [
              _createElementVNode("div", _hoisted_314, [
                _createElementVNode("div", _hoisted_315, "EXISTING EVIDENCE (" + _toDisplayString(_ctx.filteredSortedExistingEvidences.length) + ")", 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "filterButton flex",
                  onClick: _cache[58] || (_cache[58] = 
//@ts-ignore
(...args) => (_ctx.toggleExistingEvidenceFilters && _ctx.toggleExistingEvidenceFilters(...args)))
                }, [...(_cache[198] || (_cache[198] = [
                  _createElementVNode("img", {
                    src: _imports_19,
                    class: "filterIcon"
                  }, null, -1),
                  _createTextVNode(" Filters ", -1)
                ]))])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["link-existing-table-wrap", { 'link-existing-table-wrap--empty': _ctx.filteredSortedExistingEvidences.length === 0 }])
              }, [
                _createElementVNode("table", _hoisted_316, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _cache[203] || (_cache[203] = _createElementVNode("th", { class: "link-existing-col-check" }, null, -1)),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[59] || (_cache[59] = ($event: any) => (_ctx.sortExistingEvidence('filename')))
                      }, [
                        _createElementVNode("div", _hoisted_317, [
                          _cache[199] || (_cache[199] = _createElementVNode("div", { class: "table-header-label" }, "TITLE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'filename' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.sortExistingEvidence('sourceTaskId')))
                      }, [
                        _createElementVNode("div", _hoisted_318, [
                          _cache[200] || (_cache[200] = _createElementVNode("div", { class: "table-header-label" }, "TASK ID", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'sourceTaskId' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.sortExistingEvidence('evidenceType')))
                      }, [
                        _createElementVNode("div", _hoisted_319, [
                          _cache[201] || (_cache[201] = _createElementVNode("div", { class: "table-header-label" }, "TYPE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceType' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ]),
                      _createElementVNode("th", {
                        class: "cursor-pointer",
                        onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.sortExistingEvidence('evidenceDate')))
                      }, [
                        _createElementVNode("div", _hoisted_320, [
                          _cache[202] || (_cache[202] = _createElementVNode("div", { class: "table-header-label" }, "EVIDENCE DATE", -1)),
                          _createElementVNode("div", {
                            class: _normalizeClass(["sort cursor-pointer", _ctx.existingEvidenceSortKey === 'evidenceDate' ? _ctx.existingEvidenceSortClass : 'opacity-50'])
                          }, null, 2)
                        ])
                      ])
                    ]),
                    (_ctx.showExistingEvidenceFilters)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_321, [
                          _cache[204] || (_cache[204] = _createElementVNode("td", { class: "link-existing-col-check" }, null, -1)),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.existingEvidenceFilters.filename) = $event)),
                              placeholder: "Search",
                              onClick: _cache[64] || (_cache[64] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.filename,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.existingEvidenceFilters.sourceTaskId) = $event)),
                              placeholder: "Search",
                              onClick: _cache[66] || (_cache[66] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.sourceTaskId,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("td", null, [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              class: "searchForInputBoxStyling",
                              "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.existingEvidenceFilters.evidenceType) = $event)),
                              placeholder: "Search",
                              onClick: _cache[68] || (_cache[68] = _withModifiers(() => {}, ["stop"]))
                            }, null, 512), [
                              [
                                _vModelText,
                                _ctx.existingEvidenceFilters.evidenceType,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _cache[205] || (_cache[205] = _createElementVNode("td", null, null, -1))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.filteredSortedExistingEvidences.length)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_322, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredSortedExistingEvidences, (row) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: row.optionKey
                          }, [
                            _createElementVNode("td", _hoisted_323, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                checked: _ctx.isExistingEvidenceSelected(row),
                                onChange: ($event: any) => (_ctx.toggleExistingEvidence(row))
                              }, null, 40, _hoisted_324)
                            ]),
                            _createElementVNode("td", {
                              title: row.filename
                            }, _toDisplayString(row.filename), 9, _hoisted_325),
                            _createElementVNode("td", null, _toDisplayString(row.sourceTaskId), 1),
                            _createElementVNode("td", null, _toDisplayString(_ctx.getEvidenceTypeLabel(row)), 1),
                            _createElementVNode("td", null, _toDisplayString(row.evidenceDate ? _ctx.formatFileAttachedTime(row.evidenceDate) : 'N/A'), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("tbody", _hoisted_326, [...(_cache[206] || (_cache[206] = [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", {
                            class: "link-existing-empty",
                            colspan: "5"
                          }, "No Records Found")
                        ], -1)
                      ]))]))
                ])
              ], 2)
            ]),
            _createElementVNode("div", _hoisted_327, [
              _createElementVNode("button", {
                type: "button",
                class: "link-existing-cancel",
                onClick: _cache[69] || (_cache[69] = 
//@ts-ignore
(...args) => (_ctx.closeLinkEvidencePopup && _ctx.closeLinkEvidencePopup(...args)))
              }, "Cancel"),
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["link-existing-save", _ctx.selectedExistingEvidences.length === 0 ? 'link-existing-save-disabled' : '']),
                onClick: _cache[70] || (_cache[70] = 
//@ts-ignore
(...args) => (_ctx.saveLinkedEvidence && _ctx.saveLinkedEvidence(...args)))
              }, "Save", 2)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showApprovalPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 4,
          popUp: _ctx.showApprovalPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_328, [
              _cache[210] || (_cache[210] = _createElementVNode("h1", null, "Approval", -1)),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.onCrossbtn()))
              }, [...(_cache[209] || (_cache[209] = [
                _createElementVNode("img", {
                  src: _imports_16,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_329, [
              _createElementVNode("div", _hoisted_330, [
                _createElementVNode("div", _hoisted_331, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_332, [
                      _createElementVNode("div", _hoisted_333, [
                        _createElementVNode("div", _hoisted_334, [
                          _createElementVNode("div", _hoisted_335, [
                            _cache[211] || (_cache[211] = _createElementVNode("label", { class: "controllabel" }, "Name of the Authority", -1)),
                            _createElementVNode("div", null, [
                              _createVNode(_component_AutoComplete, {
                                modelValue: _ctx.taskObj.approver,
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.taskObj.approver) = $event)),
                                suggestions: _ctx.authorityOptions,
                                onComplete: _ctx.asyncFind1,
                                optionLabel: "label",
                                optionValue: "value",
                                field: "label",
                                appendTo: "self",
                                forceSelection: false,
                                placeholder: "Assigned-To",
                                class: _normalizeClass(["p-inputtext-sm systemsstyling", {
													'p-invalid':  _ctx.v$.taskObj.approver.$error,
													'has-options': _ctx.authorityOptions && _ctx.authorityOptions.length > 0,
													'no-options': !_ctx.authorityOptions.length &&  _ctx.searchValue !== '',
												}])
                              }, null, 8, ["modelValue", "suggestions", "onComplete", "class"])
                            ]),
                            (_ctx.v$.taskObj.approver.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_336, [
                                  (_ctx.v$.taskObj.approver.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_337, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_338, [
                          _createElementVNode("div", _hoisted_339, [
                            _cache[212] || (_cache[212] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Approving", -1)),
                            _withDirectives(_createElementVNode("textarea", {
                              class: _normalizeClass(["inputboxstyling mt-2", {'is-invalid': _ctx.v$.taskObj.approvalComments.$error }]),
                              placeholder: "Comments",
                              "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.taskObj.approvalComments) = $event))
                            }, null, 2), [
                              [
                                _vModelText,
                                _ctx.taskObj.approvalComments,
                                void 0,
                                { trim: true }
                              ]
                            ]),
                            (_ctx.v$.taskObj.approvalComments.$error )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_340, [
                                  (_ctx.v$.taskObj.approvalComments.$invalid )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_341, "Required"))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", null, [
                  _cache[213] || (_cache[213] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                  _createElementVNode("div", _hoisted_342, [
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary mr-1.5", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.onCancelbtnAtApproval()))
                    }, "Reset", 2),
                    _createElementVNode("button", {
                      class: _normalizeClass(["btnprimary", (JSON.stringify(_ctx.taskObj) == JSON.stringify(_ctx.taskObjDummy)) ? 'btndisabled pointer-events-none ' : 'btnprimary']),
                      onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.clickOnSaveForApproval(_ctx.taskObj)))
                    }, "Save", 2)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true),
    (_ctx.showRejectPopupAtInReview)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 5,
          popUp: _ctx.showRejectPopupAtInReview
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_343, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.isRiskTaskReject ? 'Justification to Reject the Task' : 'Justification to Reject an Approval'), 1),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.onCrossBtnForFinalApproval()))
              }, [...(_cache[214] || (_cache[214] = [
                _createElementVNode("img", {
                  src: _imports_16,
                  class: "cursor-pointer"
                }, null, -1)
              ]))])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_344, [
              _createElementVNode("div", _hoisted_345, [
                _createElementVNode("div", _hoisted_346, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_347, [
                        _createElementVNode("div", _hoisted_348, [
                          _cache[215] || (_cache[215] = _createElementVNode("label", { class: "controllabel" }, "Justification or Comments for Rejecting", -1)),
                          _withDirectives(_createElementVNode("textarea", {
                            class: _normalizeClass(["inputboxstyling mt-2", { 'is-invalid': _ctx.v$.finalJustification.justification.$error }]),
                            placeholder: "Comments",
                            "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.finalJustification.justification) = $event)),
                            onInput: _cache[78] || (_cache[78] = ($event: any) => (_ctx.v$.finalJustification.justification.$touch()))
                          }, null, 34), [
                            [
                              _vModelText,
                              _ctx.finalJustification.justification,
                              void 0,
                              { trim: true }
                            ]
                          ]),
                          (_ctx.v$.finalJustification.justification.$error)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_349, [
                                (_ctx.v$.finalJustification.justification.restrictCharacters1000.$invalid)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_350, "Charcter Limit is exceeded"))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[216] || (_cache[216] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_351, [
                  _createElementVNode("button", {
                    class: _normalizeClass(["btnprimary mr-2", 
                _ctx.finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.onCancelbtnForFinalApproval()))
                  }, " Reset ", 2),
                  _createElementVNode("button", {
                    disabled: _ctx.clickOnButtonForFinal,
                    class: _normalizeClass(["btnprimary", 
                _ctx.finalJustification.justification == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              ]),
                    onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.isRiskTaskReject ? _ctx.confirmRiskTaskReject() : _ctx.approveOrRejectForActionTasktoComplete(10410, 9)))
                  }, " Save ", 10, _hoisted_352)
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ], 2))
}